var exports = {
  "wm": "xe7b6e3d6--34677d--logo",
  "_8": "xe7b6e3d6--34677d--img",
  "DD": "xe7b6e3d6--34677d--title",
  "cL": "xe7b6e3d6--34677d--builder",
};

module.exports = exports;
